module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/signature2019-f7998a21a5b2d3a02b692abffb7e9088.png";